import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Logo from './Logo';

const FooterEl = styled.footer`
  background: #111827;
  color: white;
  padding: 2.5rem 1rem;
`;

const FooterInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const LogoWrap = styled.div`
  margin-bottom: 1rem;
`;

const Copyright = styled.p`
  color: #9ca3af;
  font-size: 0.875rem;
  margin: 0 0 0.5rem;
`;

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1rem;
  margin-bottom: 0.5rem;
`;

const FooterLink = styled.a`
  color: #60a5fa;
  font-size: 0.875rem;
  text-decoration: none;
  transition: color 0.2s;
  &:hover { color: #93c5fd; }
`;

const FooterNavLink = styled(Link)`
  color: #60a5fa;
  font-size: 0.875rem;
  text-decoration: none;
  transition: color 0.2s;
  &:hover { color: #93c5fd; }
`;

const Divider = styled.span`
  color: #374151;
  @media (max-width: 480px) { display: none; }
`;

const Footer = () => (
  <FooterEl>
    <FooterInner>
      <LogoWrap>
        <Logo dark={false} />
      </LogoWrap>
      <Copyright>© {new Date().getFullYear()} Andhra Headlines. All Rights Reserved.</Copyright>
      <Links>
        <FooterNavLink to="/about">About Us</FooterNavLink>
        <Divider>|</Divider>
        <FooterNavLink to="/contact">Contact</FooterNavLink>
        <Divider>|</Divider>
        <FooterNavLink to="/privacy-policy">Privacy Policy</FooterNavLink>
        <Divider>|</Divider>
        <FooterNavLink to="/terms">Terms of Service</FooterNavLink>
      </Links>
      <FooterLink href="mailto:editor@andhraheadlines.com">
        editor@andhraheadlines.com
      </FooterLink>
    </FooterInner>
  </FooterEl>
);

export default Footer;
